module.exports = __webpack_public_path__ + "img/message-course@2x.6b765924.png";